<div sxPadding="medium" *ngIf="(scanners$ | async)?.length > 0" sxCol sxGap="10px">
    <template-qr-view
            *ngFor="let scanner of scanners$ |async"
            [showCopy]="true"
            [scanner]="scanner"
            [showEditButton]="true"></template-qr-view>
</div>

<div
        *ngIf="(scanners$ |async)?.length < 1"
        sxCol
        sxWidth="full"
        sxGap="10px"
        sxHeight="full"
        sxAlign="center"
        sxDistribution="center">
    <img sxWidth="200px" src="assets/imgs/qid-qr-stand-outline.png" alt="img"/>
    <div sxWidth="full" sxTextAlign="center" (click)="routeToScanner()">
        <ion-icon name="add-circle-outline" size="large"></ion-icon>
        <h2 sxTextAlign="center">Link a qid QR Code stand with this template</h2>
    </div>
</div>
